import { useEffect, useState } from 'react'

function formatRate(n: number): string {
  return n.toFixed(2).replace('.', ',')
}

/** Parse "0,04" / "0.04"; null while the field is empty or still being typed ("0,"). */
function parseRate(raw: string): number | null {
  const normalized = raw.trim().replace(',', '.')
  if (!normalized || normalized === '.') return null
  if (!/^\d+(\.\d+)?$/.test(normalized)) return null
  const n = Number(normalized)
  return Number.isFinite(n) ? n : null
}

/**
 * Euro/kWh field that accepts Dutch commas and keeps partial decimals while typing.
 * Controlled `type="number"` inputs turn `0,04` / clearing into `0`.
 */
export function PricePerKwhInput({
  value,
  onChange,
  className,
}: {
  value: number
  onChange: (n: number) => void
  className?: string
}) {
  const [text, setText] = useState(() => formatRate(value))
  const [focused, setFocused] = useState(false)

  useEffect(() => {
    if (!focused) setText(formatRate(value))
  }, [value, focused])

  return (
    <input
      type="text"
      inputMode="decimal"
      className={className}
      value={text}
      onFocus={() => setFocused(true)}
      onChange={(e) => {
        const raw = e.target.value
        if (!/^[\d.,]*$/.test(raw)) return
        setText(raw)
        const n = parseRate(raw)
        if (n != null) onChange(n)
      }}
      onBlur={() => {
        setFocused(false)
        const n = parseRate(text)
        const next = n ?? value
        onChange(next)
        setText(formatRate(next))
      }}
    />
  )
}
